import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CriterionGroup } from 'shared/models/visitor-info/criterion-group';

@Component({
  selector: 'app-visitor-campaign-criterion-block',
  templateUrl: './visitor-campaign-criterion-block.component.html',
  styleUrls: ['./visitor-campaign-criterion-block.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class VisitorCampaignCriterionBlockComponent {

  @Input()
  campaignConditions: CriterionGroup;

  @Input()
  isNested = false;
}
